<epc-advanced-mdo-grid
  class="pre-pack"
  [columns]="shipTos"
  [rows]="products"
  [rowHeadTemplate]="rowHeadTemplate"
  [cellTemplate]="cellTemplate"
  [headerName]="displaySizesModeLabel"
  [portable]="portable"
  [shopTotals]="shopTotals"
  [restrictVerticalCopy]="false"
  (valuesCopied)="onCopy($event)"
  (clearShop)="clearShop.emit($event)"
>
  <ng-template #rowHeadTemplate let-row="row">
    <div class="d-flex align-items-center w-100 h-100">
      <atx-product-image
        class="img-fluid"
        [imageUrl]="row.mainImageUrl"
        [maxWidth]="imageMaxSizes.AVATAR"
        [product]="row"
        [productImageMissingVisualConfig]="productImageMissingVisualConfig"
      >
      </atx-product-image>
      <span>{{ getMaterialTitle(row) }}</span>
    </div>
  </ng-template>

  <ng-template #cellTemplate let-column="column" let-row="row">
    <input
      type="text"
      class="cell-input"
      #popoverRef="atxPopover"
      triggers="manual"
      [atxPopover]="sizeGrid"
      (atxPopoverClose)="onPopoverClose($event)"
      autoClose="outside"
      mdoNavCell
      [attr.mdoNavDisabled]="
        disabledMaterialsIds && disabledMaterialsIds[row.productId]
      "
      (keydown)="onKeydown($event)"
      (click)="
        openSizeGrid(
          popoverRef,
          column,
          disabledMaterialsIds && disabledMaterialsIds[row.productId]
        )
      "
      (keyup.enter)="
        openSizeGrid(
          popoverRef,
          column,
          disabledMaterialsIds && disabledMaterialsIds[row.productId]
        )
      "
      (keyup.backspace)="clearCell(row, column)"
      [value]="getQuantity(column, row)"
      (focus)="selectVariant({ materialId: row.displayedProductId })"
    />

    <ng-template #sizeGrid>
      <epc-size-grid
        epcGridNavigation
        rowSelector="[navRow]"
        cellSelector="[navCell]"
        disabledSelector="navDisabled"
        [deliveryShop]="column"
        [materials]="[row]"
        [deliveryItems]="{
          items: deliveryItems[column.accountId + '-' + column.addressId] ?? {}
        }"
        [availableScaleSets]="availableScaleSets"
        [sizesInventories]="sizesInventories"
        [selectedScale]="selectedScale"
        [scaleSets]="scaleSets"
        [skipInventoryCheck]="skipInventoryCheck"
        [titleAttributes]="[]"
        (quantityChange)="quantityChange($event, column)"
        (sizeSelect)="sizeSelect.emit($event)"
        [disableOutsideClick]="true"
        [focusOnFirstInput]="true"
        [showTotals]="true"
        [isNowOrder]="isNowOrder"
        [showInventoryOverview]="true"
        [showShowMoreInventories]="false"
        [differentMaterialDimensions]="differentMaterialDimensions"
      ></epc-size-grid>
    </ng-template>
  </ng-template>
</epc-advanced-mdo-grid>
